import {getTranslation} from "../get-translation";

export const HINT_CLUE1 = "HINT_CLUE1";
export const HINT_CLUE2 = "HINT_CLUE2";
export const HINT_BOMB3 = "HINT_BOMB3";
export const HINT_LETTERS4 = "HINT_LETTERS4";
export const HINT_ANSWER5 = "HINT_ANSWER5";

export const allHints = {
	HINT_CLUE1: {
		img: getTranslation("image_hint1_icon"),
		color: "#4ecdc4",
		alphaColor: "#caf0ed",
		text: "modal_hints_clue_1",
		firestoreKey: "hintClue1"
	},
	HINT_CLUE2: {
		img: getTranslation("image_hint2_icon"),
		color: "#b4e841",
		alphaColor: "#e8f8c6",
		text: "modal_hints_clue_2",
		firestoreKey: "hintClue2"
	},
	HINT_BOMB3: {
		img: getTranslation("image_hint3_icon"),
		color: "#ff6b6b",
		alphaColor: "#ffd2d2",
		text: "modal_hints_bomb_3",
		firestoreKey: "hintBomb3"
	},
	HINT_LETTERS4: {
		img: getTranslation("image_hint4_icon"),
		color: "#c44d58",
		alphaColor: "#edc9cd",
		text: "modal_hints_letters4",
		firestoreKey: "hintLetters4"
	},
	HINT_ANSWER5: {
		img: getTranslation("image_hint5_icon"),
		color: "#556270",
		alphaColor: "#ccd0d4",
		text: "modal_hints_answer5",
		firestoreKey: "hintAnswer5"
	},
}